/* eslint-disable react-hooks/exhaustive-deps */
'use client';
import { RefService } from '@/server';
import { EditorContextService } from '@magnolia/frontend-helpers-base';
import { useEffect, useRef, useState } from 'react';

const EditableComment = ({
  annotation,
  alwaysRender = false,
  shouldRefresh = false,
  shouldRunOnFrameReady = false,
}: {
  annotation: string;
  alwaysRender?: boolean;
  shouldRefresh?: boolean;
  shouldRunOnFrameReady?: boolean;
}) => {
  const commentRef = useRef<HTMLDivElement>(null);
  const [render, setRender] = useState(alwaysRender && !!annotation);
  const localRef = useRef({ commentNode: null } as {
    commentNode: Comment | null;
  });
  let magnoliaContext = RefService.getMagnoliaContextRef();

  useEffect(() => {
    if (!magnoliaContext) {
      magnoliaContext = RefService.getMagnoliaContextRef();
    }

    if (magnoliaContext?.isMagnoliaEdit && !render) {
      setRender(true);
    }
  }, [alwaysRender, annotation, magnoliaContext]);

  useEffect(() => {
    if (!render || !commentRef.current || !annotation) {
      return;
    }
    if (localRef.current.commentNode) {
      localRef.current.commentNode.remove();
    }
    const comment = document.createComment(annotation);
    localRef.current.commentNode = comment;
    commentRef.current?.before(comment);
    if (shouldRefresh) {
      setTimeout(() => {
        EditorContextService.refresh();
        if (shouldRunOnFrameReady) {
          EditorContextService.onFrameReady();
        }
      }, 0);
    }
    return () => {
      comment.remove();
    };
  }, [render, annotation, commentRef.current]);

  return render && <span style={{ display: 'none' }} ref={commentRef}></span>;
};

export default EditableComment;
